<script>
import { Component, Vue } from "vue-property-decorator";
import { mainUrl } from "@/assets/js/utils";
import Cookies from "js-cookie";
import { loginOut } from '@/assets/js/fetch'

@Component({
  props: {
    // 在未登录情况下是否跳转到登录页面默认不跳转
    isRedirect: {
      type: Boolean,
      default: false
    }
  }
})
export default class Login extends Vue {
  // isLogin = false
  // user = {}
  render() {
    return (
      <div class="login">
        <router-link tag="span" to="/list" class="login-item">
          <i class="login-icon login-icon-lb" />
          API列表
        </router-link>
        <router-link tag="span" to="/buy" class="login-item">
          <i class="login-icon login-icon-tc" />
          购买套餐
        </router-link>
        {!this.isLogin&&<span class="login-item login-item-no" onClick={this.goNewrank}>
          <svg width="1em" height="1em" fill="currentColor" aria-hidden="true" data-icon="home" viewBox="64 64 896 896" class="mr-1"><path d="M946.5 505 560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"></path></svg>
            <span style='margin-left:4px'>新榜首页</span>
          </span>}

        {this.isLogin ? (
          <div class="login-list">
            <span class="login-item" onClick={this.userConsole}>
              <i class="login-icon login-icon-kzt" />
              控制台
            </span>
            <span class="login-item">
              <el-dropdown
                class="login-item-dropdown"
                on-command={this.handleCommand}
              >
                <span class="el-dropdown-link login-item-dropdown-link">
                  <i class="login-icon login-icon-name" />
                  {this.user.nick_name || this.user.nr_name}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="user">个人中心</el-dropdown-item>
                  <el-dropdown-item command='newrank'>新榜首页</el-dropdown-item>
                  <el-dropdown-item command="signOut">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span style="margin: 0 8px;">|</span>
              <a class="login-item-href" href={this.mainUrl}>
                <i class="login-icon login-icon-nr" />
                新榜
              </a>
            </span>
          </div>
        ) : (
          <span class="login-item login-item-no" onClick={this.goLogin}>
            <i class="login-icon login-icon-lock" />
            登录
          </span>
        )}
      </div>
    );
  }
  get isLogin() {
    return this.$store.getters.getLoginStatus;
  }
  get user() {
    return this.$store.getters.getUserInfo;
  }
  created() {
    this.$store.dispatch("getLoginStatus").then(res => {
      if (res.data.value === -999 && this.isRedirect) {
        const url = encodeURIComponent(window.location.href);
        window.location.href = `${mainUrl}/user/login?backUrl=${url}`;
      }
    });
    // get('account/get').then(res => {
    //   const data = res.data.value
    //   if (data === -999) {
    //     this.isLogin = false
    //   } else {
    //     this.isLogin = true
    //     this.user = data
    //   }
    // })
  }
  mainUrl = mainUrl;
  goLogin() {
    const url = encodeURIComponent(window.location.href);
    window.location.href = `${mainUrl}/user/login?backUrl=${url}`;
  }
  goNewrank(){
    window.location.href = `https://www.newrank.cn/`;
  }
  handleCommand(command) {
    if (command === "signOut") {
      Cookies.remove("token", { path: "/xdnphb" });
      Cookies.remove("token", { path: "/" });
      Cookies.remove("token", { path: "/xdnphb", domain: ".newrank.cn" });
      Cookies.remove("token", { path: "/", domain: ".newrank.cn" });
      Cookies.remove("token", { path: "/xdnphb", domain: "newrank.cn" });
      Cookies.remove("token", { path: "/", domain: "newrank.cn" });

      return loginOut().then(res => {
        window.location.reload();
      }).catch(() => {
        window.location.reload();
      })
    }
    if (command === "user") {
      window.location.href = `${mainUrl}/account/user/user.html`;
    }
    if (command === "newrank") {
      window.location.href = `https://www.newrank.cn/`;
    }
  }
  userConsole() {
    window.location.href = `${mainUrl}/account/user/openapi.html`;
  }
}
</script>

<style lang="postcss">
@import "../../assets/css/_pub.css";
.login {
  display: flex;
  font-size: 14px;
  &-list {
    display: flex;
    align-items: center;
  }
  &-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-left: 25px;
    align-items: center;
    &-dropdown-link {
      display: flex;
      align-items: center;
    }
    &-no {
      cursor: pointer !important;
      &:hover {
        color: var(--logo-hover);
        & .login-icon-lock {
          background: url(~@/assets/img/lock-hover.png) center/cover no-repeat;
        }
      }
    }
    &:hover:not(:last-child) {
      color: var(--logo-hover);
      & .login-icon-lb {
        background: url(~@/assets/img/lb-hover.png) center/cover no-repeat;
      }
      & .login-icon-tc {
        background: url(~@/assets/img/tc-hover.png) center/cover no-repeat;
      }
      & .login-icon-kzt {
        background: url(~@/assets/img/kzt-hover.png) center/cover no-repeat;
      }
    }
    &:last-child {
      cursor: default;
    }
    &-href {
      color: var(--white);
      display: flex;
      align-items: center;
      &:hover {
        text-decoration: none;
        color: var(--logo-hover);
        & .login-icon-nr {
          background: url(~@/assets/img/zy-hover.png) center/cover no-repeat;
        }
      }
    }
    &-dropdown {
      cursor: pointer;
      color: var(--white);
      &:hover {
        color: var(--logo-hover);
        & .login-icon-name {
          background: url(~@/assets/img/name-hover.png) center/cover no-repeat;
        }
      }
    }
  }
  &-icon {
    display: inline-block;
    margin-right: 5px;
    &-lock {
      background: url(~@/assets/img/lock2.png) center/cover no-repeat;
      @mixin size 14px;
    }
    &-lb {
      background: url(~@/assets/img/lb2.png) center/cover no-repeat;
      @mixin size 12px;
    }
    &-tc {
      background: url(~@/assets/img/tc2.png) center/cover no-repeat;
      @mixin size 14px;
    }
    &-kzt {
      background: url(~@/assets/img/kzt2.png) center/cover no-repeat;
      @mixin size 14px;
    }
    &-name {
      background: url(~@/assets/img/name2.png) center/cover no-repeat;
      @mixin size 14px;
    }
    &-nr {
      background: url(~@/assets/img/zy2.png) center/cover no-repeat;
      @mixin size 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/login.vue